export const cities_eg = {
    "newCairo": "New Cairo",
    "cairo": "Cairo",
    "alexandria": "Alexandria",
    "giza": "Giza",
    "shubra": "Shubra",
    "portSaid": "Port Said",
    "suez": "Suez",
    "luxor": "Luxor",
    "mansoura": "Mansoura",
    "tanta": "Tanta",
    "asyut": "Asyut",
    "ismailia": "Ismailia",
    "fayoum": "Fayoum",
    "zagazig": "Zagazig",
    "aswan": "Aswan",
    "damietta": "Damietta",
    "damanhur": "Damanhur",
    "elMinya": "El-Minya",
    "beniSuef": "Beni Suef",
    "sohag": "Sohag",
    "hurghada": "Hurghada",
    "qena": "Qena",
    "banha": "Banha",
    "kafrElSheikh": "Kafr-El-Sheikh",
    "arish": "Arish",
    "mallawi": "Mallawi",
    "ramadan10": "10th of Ramadan",
    "marsaMatruh": "Marsa Matruh",
    "qalyub": "Qalyub",
    "matareya": "Matareya",
    "kafrElZayat": "Kafr El-Zayat",
    "badr": "Badr",
    "october6": "6th of October",
};